import React from "react";
import Initatives from "../components/Container/Initatives";
import DashboardBarGraph from "../components/Graph/ArmyGraph";
import { ArmyTopIssueContainer } from "../components/Container/ArmyTopIssueContainer";

export const ArmyDashboard = () => {
  const MildHighCounts = [
    {
      category: "Sleep_Problems",
      count: 137,
    },
    {
      category: "Mania",
      count: 84,
    },
    {
      category: "Inattention",
      count: 41,
    },
    {
      category: "Psychosis",
      count: 29,
    },
    {
      category: "Depression",
      count: 17,
    },
    {
      category: "Somatic_Symptoms",
      count: 17,
    },
    {
      category: "Repetitive_Thoughts",
      count: 15,
    },
    {
      category: "Anger",
      count: 15,
    },
    {
      category: "Suicidal_Ideation",
      count: 14,
    },
    {
      category: "Anxiety",
      count: 14,
    },
    {
      category: "Substance_Use",
      count: 4,
    },
  ];
  const data = [
    {
      "Soldier number": "1474",
      Age: "31",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "Nil",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Sleep_Problems"],
        Moderate: ["Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": "1391",
      Age: "34",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1646",
      Age: "21",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Depression", "Anger", "Somatic_Symptoms", "Substance_Use"],
        Slight: ["Mania", "Anxiety", "Psychosis", "Repetitive_Thoughts"],
        Mild: ["Suicidal_Ideation", "Sleep_Problems"],
        Moderate: ["Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": "1551",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "I am ok",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Inattention",
          "Substance_Use",
        ],
        Slight: ["Anxiety", "Psychosis", "Repetitive_Thoughts"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1631",
      Age: "30",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1435",
      Age: "29",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania", "Inattention"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1515",
      Age: "21",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Psychosis"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1667",
      Age: "23",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Anger", "Suicidal_Ideation", "Substance_Use"],
        Slight: [
          "Depression",
          "Anxiety",
          "Somatic_Symptoms",
          "Psychosis",
          "Repetitive_Thoughts",
        ],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: ["Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": "1559",
      Age: "23",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Anxiety",
          "Somatic_Symptoms",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Substance_Use",
        ],
        Slight: ["Anger", "Suicidal_Ideation", "Repetitive_Thoughts"],
        Mild: ["Depression", "Mania"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1441",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1484",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Anger", "Suicidal_Ideation", "Psychosis", "Substance_Use"],
        Slight: ["Depression", "Anxiety"],
        Mild: [
          "Mania",
          "Somatic_Symptoms",
          "Sleep_Problems",
          "Repetitive_Thoughts",
        ],
        Moderate: ["Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": "1598",
      Age: "32",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Sleep_Problems"],
        Moderate: ["Inattention"],
        High: ["Suicidal_Ideation"],
      },
    },
    {
      "Soldier number": "1365",
      Age: "36",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania", "Psychosis", "Sleep_Problems"],
        Mild: ["Inattention"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1592",
      Age: "25",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anxiety",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Substance_Use",
        ],
        Slight: ["Anger", "Mania", "Somatic_Symptoms", "Repetitive_Thoughts"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1516",
      Age: "33",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "No ",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1329",
      Age: "30",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "No",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1576",
      Age: "41",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Somatic_Symptoms", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1602",
      Age: "24",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1428",
      Age: "32",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1552",
      Age: "32",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Substance_Use",
        ],
        Slight: [
          "Anxiety",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1506",
      Age: "42",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": "1502",
      Age: "27",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "Not at all",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Psychosis",
          "Sleep_Problems",
          "Substance_Use",
        ],
        Slight: [
          "Depression",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1366",
      Age: "25",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "Mere ko jarurath nahi hai",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Sleep_Problems",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anger", "Mania", "Psychosis", "Inattention"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1606",
      Age: "30",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1258",
      Age: "30",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anxiety",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Somatic_Symptoms"],
        Mild: ["Depression", "Mania", "Sleep_Problems"],
        Moderate: ["Anger", "Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": "1661",
      Age: "26",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "No I'm fine",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1570",
      Age: "43",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "Nahin",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: ["Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": "11",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Anger", "Suicidal_Ideation", "Inattention"],
        Slight: [
          "Mania",
          "Anxiety",
          "Psychosis",
          "Sleep_Problems",
          "Repetitive_Thoughts",
        ],
        Mild: ["Depression", "Somatic_Symptoms", "Substance_Use"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1508",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Slight: ["Sleep_Problems", "Substance_Use"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1422",
      Age: "19",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1335",
      Age: "32",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1763",
      Age: "36",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1262",
      Age: "29",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Sleep_Problems"],
        Mild: [],
        Moderate: ["Mania"],
        High: [],
      },
    },
    {
      "Soldier number": "1574",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1439",
      Age: "32",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Slight: ["Depression", "Anger", "Substance_Use"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1400",
      Age: "23",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: ["Mania"],
      },
    },
    {
      "Soldier number": "1642",
      Age: "43",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Mania", "Psychosis", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1304",
      Age: "26",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania", "Somatic_Symptoms"],
        Mild: ["Sleep_Problems", "Inattention"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1287",
      Age: "42",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "No",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1431",
      Age: "30",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania", "Anxiety"],
        Mild: ["Psychosis"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1367",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1312",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Somatic_Symptoms"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1467",
      Age: "21",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Mania", "Repetitive_Thoughts"],
        Moderate: [],
        High: ["Sleep_Problems"],
      },
    },
    {
      "Soldier number": "1488",
      Age: "39",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Substance_Use"],
        Slight: ["Depression", "Mania", "Anxiety", "Suicidal_Ideation"],
        Mild: ["Psychosis", "Sleep_Problems"],
        Moderate: ["Somatic_Symptoms", "Inattention", "Repetitive_Thoughts"],
        High: ["Anger"],
      },
    },
    {
      "Soldier number": "1286",
      Age: "20",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1216",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "Use full",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania", "Somatic_Symptoms"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1605",
      Age: "20",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Suicidal_Ideation", "Psychosis"],
        Slight: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1682",
      Age: "24",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Slight: ["Depression", "Substance_Use"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1285",
      Age: "27",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Inattention"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1359",
      Age: "31",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Slight: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Psychosis",
          "Substance_Use",
        ],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1674",
      Age: "42",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1675",
      Age: "34",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Suicidal_Ideation",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Sleep_Problems"],
        Mild: ["Somatic_Symptoms"],
        Moderate: ["Mania", "Psychosis", "Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": "1275",
      Age: "34",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Inattention",
          "Substance_Use",
        ],
        Slight: [
          "Depression",
          "Anxiety",
          "Psychosis",
          "Sleep_Problems",
          "Repetitive_Thoughts",
        ],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1207",
      Age: "33",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Suicidal_Ideation",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania", "Somatic_Symptoms", "Psychosis"],
        Mild: ["Sleep_Problems", "Inattention"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1289",
      Age: "25",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Mania", "Sleep_Problems", "Inattention"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1593",
      Age: "35",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Mania", "Inattention"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1493",
      Age: "37",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Anger", "Repetitive_Thoughts", "Substance_Use"],
        Slight: [
          "Depression",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
        ],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1345",
      Age: "26",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Slight: ["Mania", "Substance_Use"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1583",
      Age: "41",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "Nahi",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Substance_Use",
        ],
        Slight: ["Depression", "Mania", "Repetitive_Thoughts"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1610",
      Age: "34",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety", "Repetitive_Thoughts"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1664",
      Age: "24",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1277",
      Age: "27",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "No",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Substance_Use",
        ],
        Slight: ["Mania", "Anxiety", "Inattention", "Repetitive_Thoughts"],
        Mild: ["Depression"],
        Moderate: ["Sleep_Problems"],
        High: [],
      },
    },
    {
      "Soldier number": "1455",
      Age: "32",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "Nahi",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1680",
      Age: "28",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "Nice work",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania", "Somatic_Symptoms"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1564",
      Age: "24",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety", "Somatic_Symptoms", "Inattention"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1376",
      Age: "27",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "Nothing",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1618",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1426",
      Age: "35",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Substance_Use",
        ],
        Slight: ["Anger", "Mania", "Sleep_Problems", "Repetitive_Thoughts"],
        Mild: ["Depression"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1568",
      Age: "26",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Inattention"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1670",
      Age: "26",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "Nahi",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Inattention"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1459",
      Age: "39",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: ["Psychosis", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1627",
      Age: "29",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: [],
        Moderate: [],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": "1276",
      Age: "36",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: " ",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania", "Anxiety", "Sleep_Problems"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1463",
      Age: "36",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": "1330",
      Age: "45",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "No",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1427",
      Age: "28",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1622",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1534",
      Age: "35",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1509",
      Age: "41",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Suicidal_Ideation", "Repetitive_Thoughts"],
        Slight: ["Anxiety", "Sleep_Problems", "Substance_Use"],
        Mild: ["Depression", "Somatic_Symptoms", "Psychosis"],
        Moderate: ["Anger", "Mania", "Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": "1407",
      Age: "32",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Mania", "Sleep_Problems", "Inattention"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1497",
      Age: "39",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "Iam ok ",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1404",
      Age: "31",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Mania"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1572",
      Age: "24",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Anger", "Mania", "Suicidal_Ideation"],
        Slight: ["Depression", "Somatic_Symptoms", "Substance_Use"],
        Mild: [
          "Anxiety",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1683",
      Age: "25",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "Nothing ",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anger", "Anxiety", "Repetitive_Thoughts"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: ["Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": "1454",
      Age: "41",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "No",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1305",
      Age: "31",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Mania", "Psychosis", "Repetitive_Thoughts"],
        Slight: ["Substance_Use"],
        Mild: ["Sleep_Problems"],
        Moderate: ["Depression", "Anxiety"],
        High: ["Anger", "Somatic_Symptoms", "Suicidal_Ideation", "Inattention"],
      },
    },
    {
      "Soldier number": "1226",
      Age: "26",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "122",
      Age: "23",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Slight: ["Mania", "Substance_Use"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1443",
      Age: "24",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "No",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1472",
      Age: "24",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1221",
      Age: "21",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "Iamok",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1554",
      Age: "35",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1560",
      Age: "35",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Slight: ["Substance_Use"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1373",
      Age: "21",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1397",
      Age: "33",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Substance_Use"],
        Slight: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1513",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: ["Anxiety"],
        High: [],
      },
    },
    {
      "Soldier number": "1202",
      Age: "29",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Sleep_Problems",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Psychosis", "Inattention"],
        Mild: ["Mania"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1668",
      Age: "21",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety", "Repetitive_Thoughts"],
        Mild: ["Psychosis"],
        Moderate: ["Sleep_Problems", "Inattention"],
        High: ["Mania"],
      },
    },
    {
      "Soldier number": "1261",
      Age: "30",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Anger", "Suicidal_Ideation", "Psychosis", "Substance_Use"],
        Slight: [
          "Depression",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Sleep_Problems",
          "Repetitive_Thoughts",
        ],
        Mild: [],
        Moderate: [],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": "6419",
      Age: "21",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Mania"],
        Mild: ["Somatic_Symptoms", "Psychosis", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1290",
      Age: "24",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Anger", "Psychosis", "Repetitive_Thoughts", "Substance_Use"],
        Slight: [
          "Depression",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
        ],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": "1473",
      Age: "43",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Somatic_Symptoms"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1218",
      Age: "43",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: ["Repetitive_Thoughts"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1245",
      Age: "30",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Sleep_Problems"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1411",
      Age: "24",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anger", "Repetitive_Thoughts"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": "1433",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Anger", "Mania", "Anxiety", "Substance_Use"],
        Slight: [
          "Depression",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1234",
      Age: "20",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1481",
      Age: "42",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "Nothing else ",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1522",
      Age: "24",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: ["Depression", "Suicidal_Ideation", "Psychosis", "Substance_Use"],
        Slight: [
          "Anxiety",
          "Somatic_Symptoms",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Mild: ["Mania"],
        Moderate: ["Anger", "Sleep_Problems"],
        High: [],
      },
    },
    {
      "Soldier number": "1363",
      Age: "28",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Slight: ["Substance_Use"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1209",
      Age: "41",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "Not at all",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Sleep_Problems"],
        Moderate: ["Anger"],
        High: [],
      },
    },
    {
      "Soldier number": "1569",
      Age: "24",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Sleep_Problems", "Inattention"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1380",
      Age: "31",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Psychosis"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1621",
      Age: "26",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "No",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Inattention"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1231",
      Age: "28",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania", "Anxiety", "Sleep_Problems"],
        Moderate: ["Depression", "Anger"],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": "1300",
      Age: "43",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1215",
      Age: "28",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Somatic_Symptoms"],
        Mild: ["Mania", "Anxiety"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1219",
      Age: "25",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Anger",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Mania", "Anxiety", "Somatic_Symptoms"],
        Mild: ["Suicidal_Ideation"],
        Moderate: ["Sleep_Problems"],
        High: [],
      },
    },
    {
      "Soldier number": "1464",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Inattention"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1294",
      Age: "33",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1430",
      Age: "25",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1389",
      Age: "30",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Slight: ["Substance_Use"],
        Mild: ["Mania", "Psychosis"],
        Moderate: ["Sleep_Problems"],
        High: [],
      },
    },
    {
      "Soldier number": "1573",
      Age: "21",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "No",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Suicidal_Ideation"],
        Mild: ["Depression", "Mania"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1457",
      Age: "43",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania", "Psychosis"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1482",
      Age: "37",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "No thanks sir ",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1562",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "I'm oll ok",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: ["Somatic_Symptoms", "Suicidal_Ideation", "Substance_Use"],
        Slight: [
          "Depression",
          "Mania",
          "Anxiety",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Mild: ["Anger"],
        Moderate: ["Sleep_Problems"],
        High: [],
      },
    },
    {
      "Soldier number": "1553",
      Age: "20",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: ["Inattention", "Substance_Use"],
        Slight: ["Depression", "Anger", "Anxiety"],
        Mild: [
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Repetitive_Thoughts",
        ],
        Moderate: ["Mania", "Somatic_Symptoms"],
        High: [],
      },
    },
    {
      "Soldier number": "1432",
      Age: "42",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety", "Sleep_Problems"],
        Mild: ["Inattention"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1510",
      Age: "34",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "No",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1279",
      Age: "23",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Mania"],
        Moderate: ["Sleep_Problems"],
        High: [],
      },
    },
    {
      "Soldier number": "1637",
      Age: "41",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania", "Anxiety", "Somatic_Symptoms", "Inattention"],
        Mild: ["Depression", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1461",
      Age: "33",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Depression", "Mania", "Psychosis", "Sleep_Problems"],
        Moderate: [],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": "1340",
      Age: "43",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1322",
      Age: "25",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "Iam ok",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Inattention"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1214",
      Age: "35",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Suicidal_Ideation",
          "Psychosis",
          "Substance_Use",
        ],
        Slight: [
          "Anxiety",
          "Somatic_Symptoms",
          "Sleep_Problems",
          "Repetitive_Thoughts",
        ],
        Mild: ["Mania"],
        Moderate: ["Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": "1571",
      Age: "29",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anger", "Mania"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": "1429",
      Age: "35",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Psychosis",
          "Substance_Use",
        ],
        Slight: [
          "Depression",
          "Anger",
          "Suicidal_Ideation",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1462",
      Age: "23",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Mania", "Anxiety"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1342",
      Age: "31",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania", "Somatic_Symptoms"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1263",
      Age: "36",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Mania", "Psychosis", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1644",
      Age: "32",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety", "Inattention"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1239",
      Age: "28",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1370",
      Age: "20",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Psychosis", "Sleep_Problems"],
        Mild: ["Mania"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1476",
      Age: "21",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety", "Somatic_Symptoms"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1543",
      Age: "25",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Mania", "Anxiety"],
        Mild: ["Anger", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1526",
      Age: "43",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: ["Anger", "Psychosis", "Sleep_Problems"],
        Slight: [
          "Depression",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Mild: ["Mania", "Substance_Use"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1487",
      Age: "23",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Psychosis", "Sleep_Problems"],
        Moderate: ["Mania"],
        High: [],
      },
    },
    {
      "Soldier number": "1587",
      Age: "24",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: [],
        Moderate: [],
        High: ["Mania"],
      },
    },
    {
      "Soldier number": "1414",
      Age: "23",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1479",
      Age: "23",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1256",
      Age: "27",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs:
        "What are healthy ways to cope with stress, anxiety, or negative thoughts?",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Suicidal_Ideation", "Psychosis", "Substance_Use"],
        Slight: [
          "Depression",
          "Anxiety",
          "Somatic_Symptoms",
          "Repetitive_Thoughts",
        ],
        Mild: ["Anger", "Mania"],
        Moderate: ["Sleep_Problems", "Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": "1632",
      Age: "21",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "Kuch bhi nahi",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety", "Psychosis"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1213",
      Age: "39",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "7568",
      Age: "36",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Anger",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Mania", "Somatic_Symptoms", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1466",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Suicidal_Ideation"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1538",
      Age: "29",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": "1358",
      Age: "33",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety", "Somatic_Symptoms"],
        Mild: ["Anger", "Mania", "Sleep_Problems"],
        Moderate: ["Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": "1480",
      Age: "43",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Psychosis", "Inattention", "Substance_Use"],
        Slight: [],
        Mild: ["Depression", "Sleep_Problems", "Repetitive_Thoughts"],
        Moderate: ["Anxiety"],
        High: ["Anger", "Mania", "Somatic_Symptoms", "Suicidal_Ideation"],
      },
    },
    {
      "Soldier number": "1386",
      Age: "23",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "Nil",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1248",
      Age: "23",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "Mein bilkul teek hu.",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
        ],
        Slight: ["Sleep_Problems", "Substance_Use"],
        Mild: ["Inattention"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1420",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "nehi chahiye",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Somatic_Symptoms",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Substance_Use",
        ],
        Slight: ["Anger", "Mania", "Anxiety", "Repetitive_Thoughts"],
        Mild: ["Suicidal_Ideation"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1532",
      Age: "29",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: ["Sleep_Problems"],
        Moderate: ["Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": "1478",
      Age: "25",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1521",
      Age: "40",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1537",
      Age: "41",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Substance_Use",
        ],
        Slight: ["Repetitive_Thoughts"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1201",
      Age: "24",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anger", "Anxiety", "Repetitive_Thoughts"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1254",
      Age: "35",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "No",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: ["Sleep_Problems"],
        Moderate: ["Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": "1601",
      Age: "33",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1282",
      Age: "43",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anger", "Psychosis"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1685",
      Age: "26",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1308",
      Age: "28",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Sleep_Problems"],
        Moderate: ["Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": "1284",
      Age: "26",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety", "Repetitive_Thoughts"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": "1490",
      Age: "29",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1541",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety", "Sleep_Problems"],
        Mild: ["Inattention"],
        Moderate: ["Mania"],
        High: [],
      },
    },
    {
      "Soldier number": "1672",
      Age: "25",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "no",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Inattention"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1405",
      Age: "20",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: ["Sleep_Problems"],
        High: [],
      },
    },
    {
      "Soldier number": "1523",
      Age: "21",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "I am ok",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Inattention"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1630",
      Age: "32",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Sleep_Problems", "Inattention"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1615",
      Age: "28",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Inattention"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1640",
      Age: "27",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Psychosis"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1369",
      Age: "20",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": "1519",
      Age: "23",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania", "Psychosis", "Inattention"],
        Mild: [],
        Moderate: ["Sleep_Problems"],
        High: [],
      },
    },
    {
      "Soldier number": "1586",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Somatic_Symptoms", "Psychosis"],
        Mild: ["Mania", "Anxiety", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1272",
      Age: "30",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: ["Suicidal_Ideation", "Inattention", "Repetitive_Thoughts"],
        Slight: [
          "Depression",
          "Anxiety",
          "Somatic_Symptoms",
          "Psychosis",
          "Sleep_Problems",
          "Substance_Use",
        ],
        Mild: ["Anger", "Mania"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1636",
      Age: "41",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: ["Somatic_Symptoms"],
        High: ["Anger", "Anxiety", "Suicidal_Ideation"],
      },
    },
    {
      "Soldier number": "1686",
      Age: "25",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "No ",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "136",
      Age: "36",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "Nil",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Suicidal_Ideation",
          "Sleep_Problems",
          "Inattention",
          "Substance_Use",
        ],
        Slight: ["Depression", "Repetitive_Thoughts"],
        Mild: ["Anxiety", "Psychosis"],
        Moderate: ["Somatic_Symptoms"],
        High: [],
      },
    },
    {
      "Soldier number": "150",
      Age: "27",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "NIL",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Suicidal_Ideation",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [
          "Somatic_Symptoms",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
        ],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1217",
      Age: "31",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Psychosis", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1597",
      Age: "23",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Suicidal_Ideation"],
        Slight: ["Anger", "Inattention", "Substance_Use"],
        Mild: ["Anxiety", "Sleep_Problems", "Repetitive_Thoughts"],
        Moderate: ["Depression", "Somatic_Symptoms", "Psychosis"],
        High: ["Mania"],
      },
    },
    {
      "Soldier number": "1212",
      Age: "23",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Suicidal_Ideation", "Substance_Use"],
        Slight: ["Anger", "Anxiety", "Somatic_Symptoms"],
        Mild: [
          "Depression",
          "Mania",
          "Psychosis",
          "Sleep_Problems",
          "Repetitive_Thoughts",
        ],
        Moderate: [],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": "1595",
      Age: "35",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Suicidal_Ideation",
          "Sleep_Problems",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety", "Somatic_Symptoms"],
        Mild: ["Mania", "Psychosis"],
        Moderate: ["Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": "1410",
      Age: "31",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [],
        Slight: [],
        Mild: [],
        Moderate: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        High: [],
      },
    },
    {
      "Soldier number": "1204",
      Age: "27",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Suicidal_Ideation",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania", "Somatic_Symptoms", "Psychosis"],
        Mild: ["Sleep_Problems", "Inattention"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1434",
      Age: "30",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1446",
      Age: "28",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1499",
      Age: "33",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "Iam ok",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1270",
      Age: "29",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "Nhi ",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1469",
      Age: "31",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1520",
      Age: "33",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "No",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Slight: ["Mania", "Substance_Use"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1594",
      Age: "35",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Suicidal_Ideation"],
        Mild: ["Somatic_Symptoms"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1230",
      Age: "31",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Depression", "Sleep_Problems", "Inattention"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1437",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety", "Sleep_Problems"],
        Mild: ["Mania"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1343",
      Age: "41",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Substance_Use",
        ],
        Slight: ["Mania", "Anxiety", "Inattention", "Repetitive_Thoughts"],
        Mild: ["Psychosis", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1475",
      Age: "43",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Psychosis",
          "Inattention",
          "Substance_Use",
        ],
        Slight: [
          "Depression",
          "Mania",
          "Suicidal_Ideation",
          "Repetitive_Thoughts",
        ],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1639",
      Age: "34",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Substance_Use",
        ],
        Slight: ["Inattention", "Repetitive_Thoughts"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1539",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1617",
      Age: "25",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "No ",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anger", "Anxiety", "Inattention"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1403",
      Age: "41",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "Nothing ",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1535",
      Age: "33",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1297",
      Age: "25",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Slight: ["Depression", "Substance_Use"],
        Mild: ["Mania", "Somatic_Symptoms", "Sleep_Problems"],
        Moderate: ["Anger"],
        High: ["Anxiety"],
      },
    },
    {
      "Soldier number": "1423",
      Age: "24",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "No",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1233",
      Age: "24",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Slight: ["Substance_Use"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1243",
      Age: "32",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Suicidal_Ideation"],
        Slight: ["Somatic_Symptoms"],
        Mild: ["Anxiety", "Substance_Use"],
        Moderate: [
          "Depression",
          "Anger",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        High: ["Mania", "Sleep_Problems"],
      },
    },
    {
      "Soldier number": "1585",
      Age: "43",
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "No",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1244",
      Age: "29",
      Gender: "Male",
      "Assessment Language": "Malayalam",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1018",
      Age: "31",
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
        ],
        Slight: [
          "Depression",
          "Somatic_Symptoms",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1249",
      Age: "22",
      Gender: "Male",
      "Assessment Language": "Kannada",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": "1253",
      Age: "21",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Substance_Use",
        ],
        Slight: ["Depression", "Somatic_Symptoms", "Repetitive_Thoughts"],
        Mild: ["Mania"],
        Moderate: [],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": "1657",
      Age: "29",
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "Yes",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Substance_Use"],
        Slight: ["Anger", "Anxiety", "Somatic_Symptoms", "Psychosis"],
        Mild: ["Mania", "Inattention", "Repetitive_Thoughts"],
        Moderate: ["Depression", "Suicidal_Ideation", "Sleep_Problems"],
        High: [],
      },
    },
    {
      "Soldier number": 1459,
      Age: 45,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Mania"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1554,
      Age: 29,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania", "Somatic_Symptoms"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1265,
      Age: 26,
      Gender: "Male",
      "Assessment Language": "Hindi",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: ["Psychosis"],
        Moderate: [],
        High: ["Suicidal_Ideation"],
      },
    },
    {
      "Soldier number": 1239,
      Age: 28,
      Gender: "Male",
      "Assessment Language": "Telugu",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Psychosis",
          "Inattention",
        ],
        Slight: [
          "Mania",
          "Suicidal_Ideation",
          "Sleep_Problems",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1408,
      Age: 23,
      Gender: "Male",
      "Assessment Language": "Hindi",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1498,
      Age: 32,
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "No",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1505,
      Age: 27,
      Gender: "Male",
      "Assessment Language": "Malyalam",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anxiety",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [
          "Depression",
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Sleep_Problems",
          "Inattention",
        ],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1368,
      Age: 21,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: ["Repetitive_Thoughts"],
        Moderate: [],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": 1394,
      Age: 25,
      Gender: "Male",
      "Assessment Language": "Hindi",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Mania",
          "Anxiety",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anger", "Somatic_Symptoms", "Sleep_Problems"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1487,
      Age: 27,
      Gender: "Male",
      "Assessment Language": "Hindi",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Psychosis"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1227,
      Age: 36,
      Gender: "Male",
      "Assessment Language": "Hindi",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: ["Anger", "Psychosis", "Substance_Use"],
        Slight: ["Depression", "Mania"],
        Mild: [
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1354,
      Age: 41,
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "no",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety", "Repetitive_Thoughts"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": 1372,
      Age: 21,
      Gender: "Male",
      "Assessment Language": "Hindi",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Inattention",
          "Substance_Use",
        ],
        Slight: [
          "Depression",
          "Mania",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
        ],
        Mild: [],
        Moderate: ["Sleep_Problems"],
        High: [],
      },
    },
    {
      "Soldier number": 1628,
      Age: 27,
      Gender: "Male",
      "Assessment Language": "Telugu",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1489,
      Age: 23,
      Gender: "Male",
      "Assessment Language": "Hindi",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Suicidal_Ideation", "Inattention", "Substance_Use"],
        Slight: ["Mania", "Repetitive_Thoughts"],
        Mild: ["Depression", "Anger", "Anxiety", "Psychosis"],
        Moderate: ["Somatic_Symptoms", "Sleep_Problems"],
        High: [],
      },
    },
    {
      "Soldier number": 1513,
      Age: 22,
      Gender: "Male",
      "Assessment Language": "Malyalam",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1431,
      Age: 30,
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "Nothing",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Mania"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1342,
      Age: 31,
      Gender: "Male",
      "Assessment Language": "Hindi",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Mania",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anger", "Anxiety", "Somatic_Symptoms"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1665,
      Age: 26,
      Gender: "Male",
      "Assessment Language": "Telugu",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Sleep_Problems"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1397,
      Age: 33,
      Gender: "Male",
      "Assessment Language": "Malyalam",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Mania", "Somatic_Symptoms", "Psychosis", "Substance_Use"],
        Slight: [
          "Depression",
          "Anxiety",
          "Suicidal_Ideation",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Mild: ["Anger"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1399,
      Age: 25,
      Gender: "Male",
      "Assessment Language": "Hindi",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania", "Sleep_Problems"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1378,
      Age: 30,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Substance_Use",
        ],
        Slight: ["Depression", "Mania", "Anxiety"],
        Mild: ["Sleep_Problems", "Inattention", "Repetitive_Thoughts"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1406,
      Age: 35,
      Gender: "Male",
      "Assessment Language": "Telugu",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1683,
      Age: 24,
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "Nothing",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Substance_Use",
        ],
        Slight: ["Anger", "Anxiety", "Repetitive_Thoughts"],
        Mild: ["Depression", "Mania"],
        Moderate: ["Sleep_Problems", "Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": 1352,
      Age: 24,
      Gender: "Male",
      "Assessment Language": "Hindi",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Psychosis", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1641,
      Age: 24,
      Gender: "Male",
      "Assessment Language": "Malyalam",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1499,
      Age: 28,
      Gender: "Male",
      "Assessment Language": "Telugu",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1613,
      Age: 22,
      Gender: "Male",
      "Assessment Language": "Hindi",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: ["Mania"],
        Moderate: ["Anger", "Inattention"],
        High: ["Sleep_Problems"],
      },
    },
    {
      "Soldier number": 1460,
      Age: 32,
      Gender: "Male",
      "Assessment Language": "Malyalam",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1652,
      Age: 32,
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "No",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Slight: ["Substance_Use"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1572,
      Age: 34,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Sleep_Problems"],
        Moderate: ["Depression"],
        High: [],
      },
    },
    {
      "Soldier number": 1605,
      Age: 20,
      Gender: "Male",
      "Assessment Language": "Telugu",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Slight: ["Substance_Use"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1596,
      Age: 27,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1584,
      Age: 37,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Mania", "Sleep_Problems", "Inattention"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1263,
      Age: 36,
      Gender: "Male",
      "Assessment Language": "Hindi",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Mania", "Psychosis", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1649,
      Age: 36,
      Gender: "Male",
      "Assessment Language": "Telugu",
      Inputs: "I'm ok",
      "Session preference": "Yes",
      Concern: "No",
      SeverityGroups: {
        None: [],
        Slight: [
          "Depression",
          "Somatic_Symptoms",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Mild: [
          "Anger",
          "Mania",
          "Anxiety",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
        ],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1274,
      Age: 25,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: ["Mania", "Suicidal_Ideation"],
        Slight: [
          "Depression",
          "Anxiety",
          "Somatic_Symptoms",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: ["Anger"],
      },
    },
    {
      "Soldier number": 1206,
      Age: 22,
      Gender: "Male",
      "Assessment Language": "Hindi",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1545,
      Age: 27,
      Gender: "Male",
      "Assessment Language": "Hindi",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Mania",
          "Suicidal_Ideation",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anger", "Psychosis", "Inattention"],
        Mild: ["Anxiety", "Somatic_Symptoms", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1591,
      Age: 27,
      Gender: "Male",
      "Assessment Language": "Telugu",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1388,
      Age: 29,
      Gender: "Male",
      "Assessment Language": "Telugu",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1447,
      Age: 31,
      Gender: "Male",
      "Assessment Language": "Telugu",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Slight: ["Mania", "Sleep_Problems", "Substance_Use"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1611,
      Age: 39,
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "No",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
        ],
        Slight: [
          "Depression",
          "Mania",
          "Anxiety",
          "Sleep_Problems",
          "Inattention",
          "Substance_Use",
        ],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1507,
      Age: 27,
      Gender: "Male",
      "Assessment Language": "Malyalam",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Substance_Use",
        ],
        Slight: ["Mania", "Anxiety", "Sleep_Problems", "Repetitive_Thoughts"],
        Mild: [],
        Moderate: [],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": 1664,
      Age: 24,
      Gender: "Male",
      "Assessment Language": "Hindi",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Sleep_Problems"],
        Moderate: ["Mania"],
        High: [],
      },
    },
    {
      "Soldier number": 1659,
      Age: 21,
      Gender: "Male",
      "Assessment Language": "Hindi",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1203,
      Age: 23,
      Gender: "Male",
      "Assessment Language": "Telugu",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1453,
      Age: 21,
      Gender: "Male",
      "Assessment Language": "Telugu",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Somatic_Symptoms", "Sleep_Problems"],
        Mild: [],
        Moderate: ["Mania"],
        High: [],
      },
    },
    {
      "Soldier number": 1229,
      Age: 32,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Depression", "Mania"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1654,
      Age: 31,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Anger", "Sleep_Problems"],
        Moderate: ["Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": 1521,
      Age: 40,
      Gender: "Male",
      "Assessment Language": "Malyalam",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Somatic_Symptoms", "Sleep_Problems"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1418,
      Age: 23,
      Gender: "Male",
      "Assessment Language": "Telugu",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
        ],
        Slight: ["Mania", "Substance_Use"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1278,
      Age: 23,
      Gender: "Male",
      "Assessment Language": "Kannada",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1547,
      Age: 42,
      Gender: "Male",
      "Assessment Language": "Malyalam",
      Inputs: "I am fine now",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Mania", "Somatic_Symptoms", "Sleep_Problems"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1424,
      Age: 36,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1364,
      Age: 29,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Suicidal_Ideation",
          "Inattention",
          "Substance_Use",
        ],
        Slight: [
          "Depression",
          "Mania",
          "Somatic_Symptoms",
          "Psychosis",
          "Sleep_Problems",
          "Repetitive_Thoughts",
        ],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1440,
      Age: 27,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: ["Suicidal_Ideation"],
      },
    },
    {
      "Soldier number": 1557,
      Age: 31,
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "I am ok",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1308,
      Age: 28,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Sleep_Problems",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: [],
        Moderate: [],
        High: ["Inattention"],
      },
    },
    {
      "Soldier number": 1384,
      Age: 32,
      Gender: "Male",
      "Assessment Language": "Kannada",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: [],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1580,
      Age: 23,
      Gender: "Male",
      "Assessment Language": "Telugu",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: ["Mania"],
        Slight: [],
        Mild: ["Psychosis", "Sleep_Problems"],
        Moderate: ["Anxiety"],
        High: [
          "Depression",
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
      },
    },
    {
      "Soldier number": 1586,
      Age: 22,
      Gender: "Male",
      "Assessment Language": "Hindi",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Psychosis", "Sleep_Problems"],
        Mild: ["Somatic_Symptoms"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1556,
      Age: 35,
      Gender: "Male",
      "Assessment Language": "Hindi",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression"],
        Mild: ["Psychosis", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1456,
      Age: 24,
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "Yennudaya sindhanaikal Adhigamaga errukindradhu",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Psychosis",
          "Substance_Use",
        ],
        Slight: ["Anxiety", "Suicidal_Ideation"],
        Mild: ["Depression", "Repetitive_Thoughts"],
        Moderate: ["Inattention"],
        High: ["Sleep_Problems"],
      },
    },
    {
      "Soldier number": 1567,
      Age: 41,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "No",
      Concern: "No",
      SeverityGroups: {
        None: [
          "Depression",
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Inattention",
          "Substance_Use",
        ],
        Slight: ["Anger", "Psychosis", "Sleep_Problems", "Repetitive_Thoughts"],
        Mild: [],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1264,
      Age: 36,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Mania"],
        Mild: ["Sleep_Problems"],
        Moderate: ["Inattention"],
        High: [],
      },
    },
    {
      "Soldier number": 1296,
      Age: 28,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: ["Inattention", "Substance_Use"],
        Slight: ["Psychosis", "Sleep_Problems"],
        Mild: [
          "Mania",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Repetitive_Thoughts",
        ],
        Moderate: ["Depression", "Anger"],
        High: [],
      },
    },
    {
      "Soldier number": 1509,
      Age: 25,
      Gender: "Male",
      "Assessment Language": "Hindi",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Anxiety",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Mania"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1432,
      Age: 32,
      Gender: "Male",
      "Assessment Language": "Tamil",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Anger",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Depression", "Anxiety"],
        Mild: ["Mania", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1329,
      Age: 30,
      Gender: "Male",
      "Assessment Language": "Tamil",
      Inputs: "No",
      "Session preference": "No",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Somatic_Symptoms",
          "Suicidal_Ideation",
          "Psychosis",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Anxiety"],
        Mild: ["Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
    {
      "Soldier number": 1663,
      Age: 31,
      Gender: "Male",
      "Assessment Language": "Hindi",
      Inputs: "No",
      "Session preference": "Yes",
      Concern: "Yes",
      SeverityGroups: {
        None: [
          "Depression",
          "Anger",
          "Mania",
          "Anxiety",
          "Suicidal_Ideation",
          "Inattention",
          "Repetitive_Thoughts",
          "Substance_Use",
        ],
        Slight: ["Somatic_Symptoms"],
        Mild: ["Psychosis", "Sleep_Problems"],
        Moderate: [],
        High: [],
      },
    },
  ];
  return (
    <div className="timeline-container" style={{ padding: "20px" }}>
      <div className="button-container">
      <a
        href="https://firebasestorage.googleapis.com/v0/b/hope-manoshala.appspot.com/o/Sheets%2FArmy%20Assessment%20and%20Logistics.xlsx?alt=media&token=72f36fe8-9b8a-45eb-a37b-198a6fa4ea49"
        download
      >
        <button className="download-btn">Download Report</button>
      </a>
      </div>
      <Initatives data={data} />

      
    </div>
  );
};
